import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { WidgetEdit } from '../../../../shared/components/widget-edit/widget-edit';

export interface MonthlyData {
    month: string;
    percentage: number;
}

@Component({
    selector: 'app-energy-expense',
    standalone: true,
    imports: [CommonModule, CdkOverlayOrigin, WidgetEdit],
    templateUrl: './energy-expense.html',
    styleUrl: './energy-expense.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnergyExpense {
    @Input() title = 'ENERGY EXPENSE';
    @Input() size: 'small' | 'medium' | 'half' | 'full' = 'medium';
    @Input() index = 0;
    @Input() isEditMode = false;
    @Input() isAddMode = false;
    @Output() addWidget = new EventEmitter<void>();
    @Input() activeDropdownIndex: number | null = null;
    @Input() getAvailableSizes!: (index: number) => Array<{ value: string; label: string }>;
    @Input() toggleSizeDropdown!: (index: number, event: Event) => void;
    @Input() changeWidgetSize!: (index: number, size: any) => void;
    @Input() removeWidget!: (index: number) => void;

    emoji = '⚡️';
    amount = '₹1,250';
    periodLabel = 'For July';
    comparisonPercentage = '+12%';
    comparisonLabel = 'More than June';

    monthlyData: MonthlyData[] = [
        { month: 'MAY', percentage: 15 },
        { month: 'JUN', percentage: 70 },
        { month: 'JUL', percentage: 100 }
    ];
}
